
import { defineComponent } from "vue";

export default defineComponent({
    components: {
    },
    mounted() {
        this.$emit('scrolltop');
    },
})
